import React, {lazy, useEffect, useState, useRef} from 'react';
import {Route, Switch, useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {logOut} from '../store/actions';
// project imports
import MainLayout from './../layout/MainLayout';


import SubscriptionErrorPage from '../views/dashboard/SubscriptionErrorPage'
import Loadable from '../ui-component/Loadable';
import AuthGuard from './../utils/route-guard/AuthGuard';

// import SessionExpiredModal from '../views/utilities/modals/SessionExpiredModal';
// import SessionPausedMessage from '../SessionPausedMessage';

import configData from '../config';
import axios from "axios";
import dashboardType from "../store/dashboard_type";

//Super Admin Dashboard Starts Here
const SuperAdminPage = Loadable(lazy(() => import('../views/dashboard/superAdmin/HomePage')));
const SuperAdminUser = Loadable(lazy(() => import('../views/dashboard/superAdmin/superAdminUser')));
const SuperAdminDevice = Loadable(lazy(() => import('../views/dashboard/superAdmin/deviceClient')));
const SuperAdminMeter = Loadable(lazy(() => import('../views/dashboard/superAdmin/addMeter')));
const SuperAdminImei = Loadable(lazy(() => import('../views/dashboard/superAdmin/superAdminImei')));
const SuperAdminMeterAccess = Loadable(lazy(() => import('../views/dashboard/superAdmin/MeterAccess')));
const SuperAdminWms = Loadable(lazy(() => import('../views/dashboard/superAdmin/superAdminWmsConfig')));
const SuperAdminDg = Loadable(lazy(() => import('../views/dashboard/superAdmin/superAdminDgConfig')));
const SuperAdminBms = Loadable(lazy(() => import('../views/dashboard/superAdmin/superAdminBmsConfig')));
const SuperAdminTemp = Loadable(lazy(() => import('../views/dashboard/superAdmin/superAdminTempConfig')));
const SuperAdminHvac = Loadable(lazy(() => import('../views/dashboard/superAdmin/superAdminHvac')));
const SuperAdminHooter = Loadable(lazy(() => import('../views/dashboard/superAdmin/superAdminHooterConfig')));
const SuperAdminFlms = Loadable(lazy(() => import('../views/dashboard/superAdmin/superAdminFlmsConfig')));
const SuperAdminView = Loadable(lazy(() => import('../views/dashboard/superAdmin/deviceView')));
const SuperAdminClientView = Loadable(lazy(() => import('../views/dashboard/superAdmin/superAdminClientView')));
const SuperAdminSiteStatus = Loadable(lazy(() => import('../views/dashboard/superAdmin/siteStatus')));
const SuperAdminHelpDesk = Loadable(lazy(() => import('../views/dashboard/superAdmin/helpDeskAdmin')));
const SuperAdminBroadcast = Loadable(lazy(() => import('../views/dashboard/superAdmin/broadcast')));
const AdminNBAudit = Loadable(lazy(() => import('../views/dashboard/superAdmin/nbaudit')));
//Super Admin Dashboard Ends Here

//Admin Dashboard Starts Here
const AdminPage = Loadable(lazy(() => import('../views/dashboard/admin/HomePage')));
const AdminUser = Loadable(lazy(() => import('../views/dashboard/admin/adminUser')));
const AdminMeter = Loadable(lazy(() => import('../views/dashboard/admin/addMeter')));
const AdminClientView = Loadable(lazy(() => import('../views/dashboard/admin/adminClientView')));
const AdminSiteView = Loadable(lazy(() => import('../views/dashboard/admin/siteStatus')));
const AdminHelpDesk = Loadable(lazy(() => import('../views/dashboard/admin/helpDeskAdmin')));
const AdminBroadcast = Loadable(lazy(() => import('../views/dashboard/admin/broadcast')));
// const AdminNBAudit = Loadable(lazy(() => import('../views/dashboard/admin/nbaudit')));
//Admin Dashboard Ends Here

// EMS Dashboard starts here
const DashboardDefault = Loadable(lazy(() => import('../views/dashboard/ems')));
const UtilsAnalysis = Loadable(lazy(() => import('../views/utilities/Analysis')));
// const UtilsComparison = Loadable(lazy(() => import('../views/utilities/MeterCompare')));
const UtilsMnv = Loadable(lazy(() => import('../views/utilities/MnV')));
const UtilsEMSAIAnalysis = Loadable(lazy(() => import('../views/dashboard/ems/EnergyAIAnalysis2')));
const UtilsAlarms = Loadable(lazy(() => import('../views/utilities/Alarms')));
const UtilsAlarmsList = Loadable(lazy(() => import('../views/utilities/AlarmsList')));
const UtilsReportGen = Loadable(lazy(() => import('../views/utilities/ReportGeneration')));
const UtilsReportAdd = Loadable(lazy(() => import('../views/utilities/AddReport')));
const UtilsPowerLog = Loadable(lazy(() => import('../views/utilities/Powerlog')));
const UtilsKpi = Loadable(lazy(() => import('../views/utilities/Kpi')));
const UtilsKpiBill = Loadable(lazy(() => import('../views/utilities/KpiBill')));
const UtilsGhg = Loadable(lazy(() => import('../views/utilities/EmissionCal')));
const UtilsAllAlert = Loadable(lazy(() => import('../views/utilities/AllSystemAlert')));
const UtilsSupport = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
const UtilsMaterialIcons = Loadable(lazy(() => import('../views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('../views/utilities/TablerIcons')));
// EMS Dashboard ends here

// Transformer Dashboard starts here
const TransformerDashboard = Loadable(lazy(() => import('../views/dashboard/trans')));
const TransformerAnalysis = Loadable(lazy(() => import('../views/dashboard/trans/analysis')));
const TransAlarms = Loadable(lazy(() => import('../views/dashboard/trans/TransAlarms')));
const TransAlarmsList = Loadable(lazy(() => import('../views/dashboard/trans/TransAlarmsList')));
const TransReport = Loadable(lazy(() => import('../views/dashboard/trans/ReportGeneration')));
const TransSchedulePage = Loadable(lazy(() => import('../views/dashboard/trans/Schedule/transSchedule')));
const TransformerHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// Transformer Dashboard ends here

// Water Dashboard starts here
const WMSDashboardDefault = Loadable(lazy(() => import('../views/dashboard/wms')));
const WMSHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// Water Dashboard ends here
//Water Quality Dashboard Starts Here
const WMSQualityDefault = Loadable(lazy(() => import('../views/dashboard/wms/Quality/WaterQuality')));
const WMSAlarmsList = Loadable(lazy(() => import('../views/dashboard/wms/WMSAlarmsList')));
const WMSQualityAlarmsList = Loadable(lazy(() => import('../views/dashboard/wms/Quality/QualityAlarmsList')));
const WMSKpi = Loadable(lazy(() => import('../views/dashboard/wms/kpi')));
//Water Quality Dashboard Ends Here
//Water Level Dashboard Starts Here
const WMSLevelDefault = Loadable(lazy(() => import('../views/dashboard/wms/Level')));
//Water Quality Dashboard Ends Here
// Switch Pages for Water Analysis,Alert and Report
const WMSAnalysisSwitchPage = Loadable(lazy(() => import('../views/dashboard/wms/wms_analysis_switch_page')));
const WMSAlertsSwitchPage = Loadable(lazy(() => import('../views/dashboard/wms/wms_alerts_switch_page')));
const WMSReportsSwitchPage = Loadable(lazy(() => import('../views/dashboard/wms/wms_reports_switch_page')));
const WMSScheduleSwitchPage = Loadable(lazy(() => import('../views/dashboard/wms/Schedule/schedule_switch_report')));
// DG Dashboard starts here
const DGDashboardDefault = Loadable(lazy(() => import('../views/dashboard/dg')));
const DGAnalysis = Loadable(lazy(() => import('../views/dashboard/dg/Analysis')));
const DGAlarms = Loadable(lazy(() => import('../views/dashboard/dg/DGAlarms')));
const DGAlarmsList = Loadable(lazy(() => import('../views/dashboard/dg/DGAlarmsList')));
const DGReport = Loadable(lazy(() => import('../views/dashboard/dg/ReportGeneration')));
const DGSchedulePage = Loadable(lazy(() => import('../views/dashboard/dg/Schedule/ScheduleDG')));
const DGHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// DG Dashboard ends here

// BMS Dashboard starts here
const BMSDashboardDefault = Loadable(lazy(() => import('../views/dashboard/bms')));
const BMSAnalysis = Loadable(lazy(() => import('../views/dashboard/bms/bms_analysis_switch_page')));
const BMSAlarms = Loadable(lazy(() => import('../views/dashboard/bms/bms_alerts_switch_page')));
const BMSAlarmsList = Loadable(lazy(() => import('../views/dashboard/bms/BMSAlarmsList')));
const BMSReport = Loadable(lazy(() => import('../views/dashboard/bms/Reports/reports_switch_page')));
const BMSSchedulePage = Loadable(lazy(() => import('../views/dashboard/bms/Schedule/schedule_switch_report')));
const BMSHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// BMS Dashboard ends here

// TEMP Dashboard starts here
const TEMPDashboardDefault = Loadable(lazy(() => import('../views/dashboard/temp')));
const TempAlarmsListPage = Loadable(lazy(() => import('../views/dashboard/temp/TEMPAlarmsList')));
// const TEMPHooterList = Loadable(lazy(() => import('../views/dashboard/temp/TEMPHooterList')));
const TempHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
//Indoor Dashboard Code
const INDOORDashboardDefault = Loadable(lazy(() => import('../views/dashboard/temp/Indoor/IndoorDashboard')));
const IndoorAlarmsListPage = Loadable(lazy(() => import('../views/dashboard/temp/Indoor/IndoorAlarmsList')));
const INDOORHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
//Outdoor Dashboard Code
const OutdoorDashboardDefault = Loadable(lazy(() => import('../views/dashboard/temp/Outdoor/OutdoorDashboard')));
const OutDoorAlarmsListPage = Loadable(lazy(() => import('../views/dashboard/temp/Outdoor/OutdoorAlarmsList')));
// Switch Pages for Temp/Indoor/Outdoor
const TempAnalysisSwitchPage = Loadable(lazy(() => import('../views/dashboard/temp/temp_analysis_switch_page')));
const TempAlertsSwitchPage = Loadable(lazy(() => import('../views/dashboard/temp/temp_alerts_switch_page')));
const TempReportsSwitchPage = Loadable(lazy(() => import('../views/dashboard/temp/temp_reports_switch_page')));
//Weather Station Dashboard Code
const WeatherStationMainPage = Loadable(lazy(() => import('../views/dashboard/temp/WeatherStation/WeatherDashboard')));
const WeatherIndividualPage = Loadable(lazy(() => import('../views/dashboard/temp/WeatherStation/weatherMainPage')));

//Weather Station Dashboard Code
const BusBarMainPage = Loadable(lazy(() => import('../views/dashboard/temp/BusBar/BusDashboard')));
const BusBarAlarmsListPage = Loadable(lazy(() => import('../views/dashboard/temp/BusBar/BusAlarmsList')));
const BusBarHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));

const TempScheduleSwitchPage = Loadable(lazy(() => import('../views/dashboard/temp/Schedule/schedule_switch_report')));
// TEMP Dashboard ends here

// Fire Dashboard starts here
const FMSDashboardDefault = Loadable(lazy(() => import('../views/dashboard/fms/pages/dashboard')));
const FMSDashboardpage = Loadable(lazy(() => import('../views/dashboard/fms/pages/fire_panel')));
const FMSDashboardAnalysis = Loadable(lazy(() => import('../views/dashboard/fms/analysis')));
const FMSPumpAnalysis = Loadable(lazy(() => import('../views/dashboard/fms/pumpAnalysis')));
const FMSPressureAnalysis = Loadable(lazy(() => import('../views/dashboard/fms/pressureAnalysis')));
const FMSDieselAnalysis = Loadable(lazy(() => import('../views/dashboard/fms/dieselAnalysis')));
const FMSWaterAnalysis = Loadable(lazy(() => import('../views/dashboard/fms/waterAnalysis')));
const FMSAlertSwitchPage = Loadable(lazy(() => import('../views/dashboard/fms/alerts_switch_page')));
const FMSAlertLog = Loadable(lazy(() => import('../views/dashboard/fms/AlertLog')));
const FMSAlarmsList = Loadable(lazy(() => import('../views/dashboard/fms/panelCards/alarmSystemList')));

const FMSVentpage = Loadable(lazy(() => import('../views/dashboard/fms/pages/ventilation/ventPage')));
const FMSPASystempage = Loadable(lazy(() => import('../views/dashboard/fms/pages/paSystem/paSystemPage')));
const FMSHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// Fire Dashboard ends here

// Boiler Dashboard starts here
const BoilerDashboardDefault = Loadable(lazy(() => import('../views/dashboard/boiler')));
const BoilerDashboardPage = Loadable(lazy(() => import('../views/dashboard/boiler/MainDashboard')));
const BoilerAnalysis = Loadable(lazy(() => import('../views/dashboard/boiler/analysis')));
const BoilerAlarmsPage = Loadable(lazy(() => import('../views/dashboard/boiler/BoilerAlarms')));
const BoilerAlertsPage = Loadable(lazy(() => import('../views/dashboard/boiler/BoilerAlarmsList')));
const BoilerReportsPage = Loadable(lazy(() => import('../views/dashboard/boiler/ReportGeneration')));
const BoilerSchedulePage = Loadable(lazy(() => import('../views/dashboard/boiler/Schedule/boilerSchedule')));
const BoilerHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// Boiler Dashboard ends here

// HVAC Dashboard starts here
const HVCDashboardDefault = Loadable(lazy(() => import('../views/dashboard/hvc')));
const HVCAnalysisSwitchPage = Loadable(lazy(() => import('../views/dashboard/hvc/analysis_switch_page')));
const HVCAlertsSwitchPage = Loadable(lazy(() => import('../views/dashboard/hvc/alerts_switch_page')));
const HVCReportsSwitchPage = Loadable(lazy(() => import('../views/dashboard/hvc/Reports/reports_switch_page')));
const HVCAlarmsListPage = Loadable(lazy(() => import('../views/dashboard/hvc/dashboard/Dex/DexAlarmsList')));
const HVCChillerAlarmsPage = Loadable(lazy(() => import('../views/dashboard/hvc/dashboard/Chiller/ChillerAlarmsList')));
const HVCAHUAlarmsPage = Loadable(lazy(() => import('../views/dashboard/hvc/dashboard/Ahu/AhuAlarmsList')));
const HVCSchedulePage = Loadable(lazy(() => import('../views/dashboard/hvc/Schedule/schedule_switch_report')));
const HVCHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// HVAC Dashboard ends here

// Pump Dashboard starts here
const PumpsDashboardDefault = Loadable(lazy(() => import('../views/dashboard/Pumps')));
const PumpsDashboardMainDefault = Loadable(lazy(() => import('../views/dashboard/Pumps/Cards/PumpPage')));
const PumpsAnalysis = Loadable(lazy(() => import('../views/dashboard/Pumps/PumpAnalysis')));
const PumpsAlarms = Loadable(lazy(() => import('../views/dashboard/Pumps/PumpsAlarms')));
const PumpsAlarmsList = Loadable(lazy(() => import('../views/dashboard/Pumps/PumpsAlarmsList')));
const PumpsReport = Loadable(lazy(() => import('../views/dashboard/Pumps/PumpsReport')));
const PumpsSchedulePage = Loadable(lazy(() => import('../views/dashboard/Pumps/Schedule/pumpsSchedule')));
const PumpsAIReport = Loadable(lazy(() => import('../views/dashboard/Pumps/AIReport')));
const PumpsHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// Pump Dashboard ends here

// Vibration Dashboard starts here
const VibDashboardDefault = Loadable(lazy(() => import('../views/dashboard/vib')));
const VibOverview = Loadable(lazy(() => import('../views/dashboard/vib/dashboardType/SingleView')));
const VibAlarms = Loadable(lazy(() => import('../views/dashboard/vib/vib_alerts_switch_page')));
const VibAlarmsList = Loadable(lazy(() => import('../views/dashboard/vib/alarmsList')));
const WindAnalysisSwitchPage = Loadable(lazy(() => import('../views/dashboard/vib/vib_analysis_switch_page')));
const VibReport = Loadable(lazy(() => import('../views/dashboard/vib/vib_reports_switch_page.js')));
const VibAIReport = Loadable(lazy(() => import('../views/dashboard/vib/vib_ai_switch_page')));
const VibSchedulePage = Loadable(lazy(() => import('../views/dashboard/vib/Schedule/vibSchedule')));
const VibHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
const WindOverview = Loadable(lazy(() => import('../views/dashboard/vib/dashboardType/WindSingleView')));
const WindAlarmsList = Loadable(lazy(() => import('../views/dashboard/vib/windMill/windAlarmsList')));
// Vibration Dashboard ends here

//NBSafe Dashboard Starts here
const NBSDashboardDefault = Loadable(lazy(() => import('../views/dashboard/nbs')));
const NBSAnalysisDefault = Loadable(lazy(() => import('../views/dashboard/nbs/Analysis/analysis')));
const NBSAlarms = Loadable(lazy(() => import('../views/dashboard/nbs/NBSAlarms')));
const NBSMeteringDefault = Loadable(lazy(() => import('../views/dashboard/nbs/ems')));
const NBSHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
//NBSafe Dashboard Ends here

// Agriculture Dashboard starts here
const AGRDashboardDefault = Loadable(lazy(() => import('../views/dashboard/agr')));
const AGRHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// Agriculture Dashboard ends here

// Gas Dashboard starts here
const GasDashboardDefault = Loadable(lazy(() => import('../views/dashboard/gas')));
const GasAnalysis = Loadable(lazy(() => import('../views/dashboard/gas/analysis')));
const GasAlarms = Loadable(lazy(() => import('../views/dashboard/gas/alarms')));
const GasAlarmsList = Loadable(lazy(() => import('../views/dashboard/gas/alarmsList')));
const GasReport = Loadable(lazy(() => import('../views/dashboard/gas/ReportGeneration')));
const GasSchedulePage = Loadable(lazy(() => import('../views/dashboard/gas/Schedule/gasSchedule')));
const GasHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// Gas Dashboard ends here

// Steam Dashboard starts here
const SteamDashboardDefault = Loadable(lazy(() => import('../views/dashboard/steam')));
const SteamAnalysis = Loadable(lazy(() => import('../views/dashboard/steam/analysis')));
const SteamAlarms = Loadable(lazy(() => import('../views/dashboard/steam/alarms')));
const SteamAlarmsList = Loadable(lazy(() => import('../views/dashboard/steam/alarmsList')));
const SteamReport = Loadable(lazy(() => import('../views/dashboard/steam/ReportGeneration')));
const SteamSchedulePage = Loadable(lazy(() => import('../views/dashboard/steam/Schedule/steamSchedule')));
const SteamHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// Steam Dashboard ends here

// Air Compressor Dashboard starts here
const AirDashboardDefault = Loadable(lazy(() => import('../views/dashboard/air')));
// const AirMainDashboard = Loadable(lazy(() => import('../views/dashboard/air/AirDashboard')));
const AirAnalysis = Loadable(lazy(() => import('../views/dashboard/air/analysis')));
const AirAlarms = Loadable(lazy(() => import('../views/dashboard/air/alarms')));
const AirAlarmsList = Loadable(lazy(() => import('../views/dashboard/air/alarmsList')));
const AirReport = Loadable(lazy(() => import('../views/dashboard/air/ReportGeneration')));
const AirSchedulePage = Loadable(lazy(() => import('../views/dashboard/air/Schedule/ScheduleAir')));
const AirPowerLog = Loadable(lazy(() => import('../views/dashboard/air/Powerlog')));
const AirBackupLog = Loadable(lazy(() => import('../views/dashboard/air/Backuplog.js')));
const AirHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// Air Compressor Dashboard ends here

// FLMS  Dashboard starts here
const FlmsDashboardDefault = Loadable(lazy(() => import('../views/dashboard/flms')));
const FlmsDetailsPage = Loadable(lazy(() => import('../views/dashboard/flms/details')));
const FlmsDriversPage = Loadable(lazy(() => import('../views/dashboard/flms/drivers')));
const FlmsDriverLogScreen = Loadable(lazy(() => import('../views/dashboard/flms/driverLogScreen')));
const FlmsStatistics = Loadable(lazy(() => import('../views/dashboard/flms/fuelStatisticsScreen')));
const FlmsOwnStatistics = Loadable(lazy(() => import('../views/dashboard/flms/flmsOwn/Tables/stats')));
const FlmsOwnDetails = Loadable(lazy(() => import('../views/dashboard/flms/flmsOwn/VehicleDetail')));
const FlmsAlarms = Loadable(lazy(() => import('../views/dashboard/flms/flmsOwn/VehicleAlarms')));
const FlmsAlarmsList = Loadable(lazy(() => import('../views/dashboard/flms/flmsOwn/VehicleAlarmsList')));
const FlmsReport = Loadable(lazy(() => import('../views/dashboard/flms/flmsOwn/ReportGeneration')));
const FlmsSchedulePage = Loadable(lazy(() => import('../views/dashboard/flms/flmsOwn/Schedule/vehicleSchedule')));
const FlmsHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// FLMS  Dashboard ends here

// Solar  Dashboard starts here
const SolarHome = Loadable(lazy(() => import('../views/dashboard/solar')));
const SolarAnalysis = Loadable(lazy(() => import('../views/dashboard/solar/analysis_page')));
const SolarDetails = Loadable(lazy(() => import('../views/dashboard/solar/details_page')));
const SolarAlarms = Loadable(lazy(() => import('../views/dashboard/solar/component/alerts_page/SolarAlerts')));
const SolarAlarmsList = Loadable(lazy(() => import('../views/dashboard/solar/component/alerts_page/SolarAlertsList')));
const SolarHelpDesk = Loadable(lazy(() => import('../views/utilities/HelpDesk')));
// Solar  Dashboard ends here

//Support Dashboard Starts Here
const TechHelpDesk = Loadable(lazy(() => import('../views/dashboard/admin/helpDeskAdmin')));
//Support Dashboard Ends Here

// sample page routing
const SamplePage = Loadable(lazy(() => import('../views/sample-page')));
const NotFound = Loadable(lazy(() => import('../views/dashboard/notFound')));

//-----------------------|| MAIN ROUTING ||-----------------------//
const MainRoutes = () => {
    const location = useLocation();
    const account = useSelector((state) => state.account);
    // const [isSessionExpiredModalOpen, setIsSessionExpiredModalOpen] = useState(false);
    // const [isSessionPaused, setIsSessionPaused] = useState(false);
    // const [isScreenVisible, setIsScreenVisible] = useState(true);
    // const logOutUserLastVisitTimeout = 40 * 60 * 1000; 
    // const pauseUserNoActivityTimeout = 10 * 60 * 1000;
    // const checkUserTokenIsValidInterval = 60 * 1000; 
    const dispatcher = useDispatch();
    const [timeSpentStartTime, setTimeSpentStartTime] = useState(Date.now());
    // const autoLogoutTimeoutRef = useRef(null);

    async function checkTokenStatus(token) {
        try {
            const url = `${configData.API_SERVER}user/check_token`;
            const formData = new FormData();
            const timeSpent = calculateUserSpend()
            formData.append('token', token);
            formData.append('time_spent', timeSpent);
            // Send current time spent while checking token
            const response = await axios.post(url, formData);
            // if (response.status === 200 && response.data.active === false) {
            //     logoutUser();
            // }
        } catch (error) {
            console.error('Error checking token status:', error);
        }
    }

    const calculateUserSpend = () => {
        const now = Date.now()
        const timeSpent = Math.round((now - timeSpentStartTime) / 1000); // Time in seconds
        setTimeSpentStartTime(now);
        return timeSpent;
    }

    return(
        <div>

            <Switch location={location} key={location.pathname} >
                <Route path="/subscription">
                    <SubscriptionErrorPage/>
                </Route>

                <Route
                    path={['/superAdmin', '/superAdmin/home', '/superAdmin/user', '/superAdmin/device', '/superAdmin/meter', '/superAdmin/imei', '/superAdmin/bms', '/superAdmin/hooter', '/superAdmin/flms', '/superAdmin/temp', '/superAdmin/hvac', '/superAdmin/wms', '/superAdmin/dg', '/superAdmin/view', '/superAdmin/client', '/superAdmin/site', '/superAdmin/help', '/superAdmin/broadcast','/superAdmin/nbaudit']}>
                    <MainLayout type={dashboardType.superAdmin}>
                        <AuthGuard>
                            <Route path="/superAdmin/home" component={SuperAdminPage}/>
                            <Route path="/superAdmin/user" component={SuperAdminUser}/>
                            <Route path="/superAdmin/device" component={SuperAdminDevice}/>
                            <Route path="/superAdmin/meter" component={SuperAdminMeter}/>
                            <Route path="/superAdmin/imei" component={SuperAdminImei}/>
                            <Route path="/superAdmin/bms" component={SuperAdminBms}/>
                            <Route path="/superAdmin/hooter" component={SuperAdminHooter}/>
                            <Route path="/superAdmin/flms" component={SuperAdminFlms}/>
                            <Route path="/superAdmin/temp" component={SuperAdminTemp}/>
                            <Route path="/superAdmin/hvac" component={SuperAdminHvac}/>
                            <Route path="/superAdmin/wms" component={SuperAdminWms}/>
                            <Route path="/superAdmin/dg" component={SuperAdminDg}/>
                            <Route path="/superAdmin/access" component={SuperAdminMeterAccess}/>
                            <Route path="/superAdmin/view" component={SuperAdminView}/>
                            <Route path="/superAdmin/client" component={SuperAdminClientView}/>
                            <Route path="/superAdmin/site" component={SuperAdminSiteStatus}/>
                            <Route path="/superAdmin/help" component={SuperAdminHelpDesk}/>
                            <Route path="/superAdmin/broadcast" component={SuperAdminBroadcast}/>
                            <Route path="/superAdmin/nbaudit" component={AdminNBAudit}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route
                    path={['/admin', '/admin/home', '/admin/user', '/admin/meter', '/admin/client', '/admin/help', '/admin/broadcast']}>
                    <MainLayout type={dashboardType.admin}>
                        <AuthGuard>
                            <Route path="/admin/home" component={AdminPage}/>
                            <Route path="/admin/user" component={AdminUser}/>
                            <Route path="/admin/meter" component={AdminMeter}/>
                            <Route path="/admin/client" component={AdminClientView}/>
                            <Route path="/admin/site" component={AdminSiteView}/>
                            <Route path="/admin/help" component={AdminHelpDesk}/>
                            <Route path="/admin/broadcast" component={AdminBroadcast}/>
                            {/* <Route path="/admin/nbaudit" component={AdminNBAudit}/> */}
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/dg', '/dg/home', '/dg/analysis', '/dg/alarms', '/dg/alarms_list', '/dg/report','/dg/all/alert','/dg/schedule','/dg/help']}>
                    <MainLayout type={dashboardType.dg}>
                        <AuthGuard>
                            <Route path="/dg/home" component={DGDashboardDefault}/>
                            <Route path="/dg/analysis" component={DGAnalysis}/>
                            <Route path="/dg/alarms" component={DGAlarms}/>
                            <Route path="/dg/alarms_list" component={DGAlarmsList}/>
                            <Route path="/dg/report" component={DGReport}/>
                            <Route path="/dg/schedule" component={DGSchedulePage}/>
                            <Route path="/dg/all/alert" component={UtilsAllAlert}/>
                            <Route path="/dg/help" component={DGHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/bms', '/bms/home', '/bms/analysis', '/bms/alarms', '/bms/alarms_list','/bms/report','/bms/all/alert','/bms/schedule','/bms/help']}>
                    <MainLayout type={dashboardType.bms}>
                        <AuthGuard>
                            <Route path="/bms/home" component={BMSDashboardDefault}/>
                            <Route path="/bms/analysis" component={BMSAnalysis}/>
                            <Route path="/bms/alarms" component={BMSAlarms}/>
                            <Route path="/bms/alarms_list" component={BMSAlarmsList}/>
                            <Route path="/bms/report" component={BMSReport}/>
                            <Route path="/bms/schedule" component={BMSSchedulePage}/>
                            <Route path="/bms/all/alert" component={UtilsAllAlert}/>
                            <Route path="/bms/help" component={BMSHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/temp', '/temp/home', '/temp/analysis','/temp/alarms','/temp/report','/temp/all/alert','/temp/help','/temp/indoor','/temp/indoor/home','/temp/indoor/analysis','/temp/indoor/all/alert','/temp/indoor/alarms_list','/temp/outdoor/home','/temp/outdoor/analysis','/temp/outdoor/alarms_list','/temp/outdoor/pm25','/temp/outdoor/pm10','/temp/outdoor/co','/temp/outdoor/so2','/temp/outdoor/no2','/temp/outdoor/o3','/temp/outdoor/all/alert','/temp/schedule','/temp/weather/home','/temp/weather/all/alert','/temp/weather/analysis', '/temp/busBar/home', '/temp/busBar/alarms_list', '/temp/busBar/all/alert','/temp/busBar/help']}>
                    <MainLayout type={dashboardType.temp}>
                        <AuthGuard>
                            <Route path="/temp/home" component={TEMPDashboardDefault}/>
                            <Route path="/temp/analysis" component={TempAnalysisSwitchPage}/>
                            <Route path="/temp/alarms" component={TempAlertsSwitchPage}/>
                            <Route path="/temp/alarms_list" component={TempAlarmsListPage}/>
                            {/* <Route path="/temp/hooter_list" component={TEMPHooterList}/> */}
                            <Route path="/temp/report" component={TempReportsSwitchPage}/>
                            <Route path="/temp/schedule" component={TempScheduleSwitchPage}/>
                            <Route path="/temp/all/alert" component={UtilsAllAlert}/>
                            <Route path="/temp/help" component={TempHelpDesk}/>

                            <Route path="/temp/indoor/home" component={INDOORDashboardDefault}/>
                            <Route path="/temp/indoor/alarms_list" component={IndoorAlarmsListPage}/>
                            <Route path="/temp/indoor/all/alert" component={UtilsAllAlert}/>
                            <Route path="/temp/indoor/help" component={INDOORHelpDesk}/>

                            <Route path="/temp/outdoor/home" component={OutdoorDashboardDefault}/>
                            <Route path="/temp/outdoor/alarms_list" component={OutDoorAlarmsListPage}/>
                            <Route path="/temp/outdoor/all/alert" component={UtilsAllAlert}/>

                            <Route path="/temp/weather/home" component={WeatherStationMainPage}/>
                            <Route path="/temp/weather/analysis" component={WeatherIndividualPage}/>
                            <Route path="/temp/weather/all/alert" component={UtilsAllAlert}/>

                            <Route path="/temp/busBar/home" component={BusBarMainPage}/>
                            <Route path="/temp/busBar/alarms_list" component={BusBarAlarmsListPage}/>
                            <Route path="/temp/busBar/all/alert" component={UtilsAllAlert}/>
                            <Route path="/temp/busBar/help" component={BusBarHelpDesk}/>

                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/fms', '/fms/home','/fms/panel', 'fms/analysis', 'fms/alarms', '/fms/pumpAnalysis','fms/alarms_list','fms/pressureAnalysis', 'fms/waterAnalysis','fms/dieselAnalysis', '/fms/vent_system','/fms/all/alert','/fms/pa_system','fms/help','/fms/log']}>
                    <MainLayout type={dashboardType.fms}>
                        <AuthGuard>
                            <Route path="/fms/home" component={FMSDashboardDefault}/>
                            <Route path="/fms/panel" component={FMSDashboardpage}/>
                            <Route path="/fms/analysis" component={FMSDashboardAnalysis}/>
                            <Route path="/fms/alarms" component={FMSAlertSwitchPage}/>
                            <Route path="/fms/alarms_list" component={FMSAlarmsList}/>
                            <Route path="/fms/pumpAnalysis" component={FMSPumpAnalysis}/>
                            <Route path="/fms/pressureAnalysis" component={FMSPressureAnalysis}/>
                            <Route path="/fms/dieselAnalysis" component={FMSDieselAnalysis}/>
                            <Route path="/fms/waterAnalysis" component={FMSWaterAnalysis}/>
                            <Route path="/fms/log" component={FMSAlertLog}/>
                            <Route path="/fms/vent_system" component={FMSVentpage}/>
                            <Route path="/fms/pa_system" component={FMSPASystempage}/>
                            <Route path="/fms/all/alert" component={UtilsAllAlert}/>
                            <Route path="/fms/help" component={FMSHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/boiler', '/boiler/home', 'boiler/dashboard', 'boiler/analysis', '/boiler/alarms', '/boiler/alarms_list','/boiler/report','/boiler/schedule','/boiler/all/alert','boiler/help']}>
                    <MainLayout type={dashboardType.boiler}>
                        <AuthGuard>
                            <Route path="/boiler/home" component={BoilerDashboardDefault}/>
                            <Route path="/boiler/dashboard" component={BoilerDashboardPage}/>
                            <Route path="/boiler/analysis" component={BoilerAnalysis}/>
                            <Route path="/boiler/alarms" component={BoilerAlarmsPage}/>
                            <Route path="/boiler/alarms_list" component={BoilerAlertsPage}/>
                            <Route path="/boiler/report" component={BoilerReportsPage}/>
                            <Route path="/boiler/schedule" component={BoilerSchedulePage}/>
                            <Route path="/boiler/all/alert" component={UtilsAllAlert}/>
                            <Route path="/boiler/help" component={BoilerHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/hvc', '/hvc/home', 'hvc/analysis','/hvc/report','/hvc/all/alert','/hvc/schedule','hvc/help','hvc/ahu_alarms_list','/hvc/chiller/all/alert','hvc/chiller/alarms_list']}>
                    <MainLayout type={dashboardType.hvc}>
                        <AuthGuard>
                            <Route path="/hvc/home" component={HVCDashboardDefault}/>
                            <Route path="/hvc/analysis" component={HVCAnalysisSwitchPage}/>
                            <Route path="/hvc/alarms" component={HVCAlertsSwitchPage}/>
                            <Route path="/hvc/alarms_list" component={HVCAlarmsListPage}/>
                            <Route path="/hvc/chiller/alarms_list" component={HVCChillerAlarmsPage}/>
                            <Route path="/hvc/ahu_alarms_list" component={HVCAHUAlarmsPage}/>
                            <Route path="/hvc/report" component={HVCReportsSwitchPage}/>
                            <Route path="/hvc/schedule" component={HVCSchedulePage}/>
                            <Route path="/hvc/all/alert" component={UtilsAllAlert}/>                               
                            <Route path="/hvc/help" component={HVCHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/pump', '/pump/home','/pump/dash','/pump/analysis','/pump_alarms','/pump_alarms_list','/pump/ai_insights','/pump/schedule','/pump/report','/pump/help']}>
                    <MainLayout type={dashboardType.pump}>
                        <AuthGuard>
                            <Route path="/pump/home" component={PumpsDashboardDefault}/>
                            <Route path="/pump/dash" component={PumpsDashboardMainDefault}/>
                            <Route path="/pump/analysis" component={PumpsAnalysis}/>
                            <Route path="/pump/alarms" component={PumpsAlarms}/>
                            <Route path="/pump/alarms_list" component={PumpsAlarmsList}/>
                            <Route path="/pump/report" component={PumpsReport}/>
                            <Route path="/pump/ai_insights" component={PumpsAIReport}/> 
                            <Route path="/pump/all/alert" component={UtilsAllAlert}/>        
                            <Route path="/pump/schedule" component={PumpsSchedulePage}/>                            
                            <Route path="/pump/help" component={PumpsHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/vib', '/vib/home','/vib/overview','/vib/wind/overview','vib/analysis','/vib/all/alert','vib/alarms','/vib/wind/alarms_list','vib/alarms_list','vib/report','vib/schedule','vib/ai_insights', 'vib/help','/vib/wind/all/alert','/vib/wind/help',]}>
                    <MainLayout type={dashboardType.vib}>
                        <AuthGuard>
                            <Route path="/vib/home" component={VibDashboardDefault}/>
                            <Route path="/vib/overview" component={VibOverview}/>
                            <Route path="/vib/alarms" component={VibAlarms}/>
                            <Route path="/vib/alarms_list" component={VibAlarmsList}/>
                            <Route path="/vib/analysis" component={WindAnalysisSwitchPage}/>
                            <Route path="/vib/ai_insights" component={VibAIReport}/>
                            <Route path="/vib/report" component={VibReport}/>
                            <Route path="/vib/all/alert" component={UtilsAllAlert}/>
                            <Route path="/vib/schedule" component={VibSchedulePage}/>
                            <Route path="/vib/help" component={VibHelpDesk}/>
                            <Route path="/vib/wind" component={WindOverview}/>
                            <Route path="/vib/wind/all/alert" component={UtilsAllAlert}/>
                            <Route path="/vib/wind/alarms_list" component={WindAlarmsList}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/wms', '/wms/home', '/wms/analysis','/wms/alarms_list','/wms/quality/alarms_list','/wms/level','/wms/kpi','/wms/level/all/alert','/wms/report','/wms/help','/wms/all/alert','/wms/quality','/wms/schedule']}>
                    <MainLayout type={dashboardType.wms}>
                        <AuthGuard>
                            <Route path="/wms/home" component={WMSDashboardDefault}/>
                            <Route path="/wms/analysis" component={WMSAnalysisSwitchPage}/>
                            <Route path="/wms/alarms" component={WMSAlertsSwitchPage}/>
                            <Route path="/wms/alarms_list" component={WMSAlarmsList}/>
                            <Route path="/wms/level" component={WMSLevelDefault}/>
                            <Route path="/wms/quality_list" component={WMSQualityAlarmsList}/>
                            <Route path="/wms/report" component={WMSReportsSwitchPage}/>
                            <Route path="/wms/kpi" component={WMSKpi}/>
                            <Route path="/wms/schedule" component={WMSScheduleSwitchPage}/>
                            <Route path="/wms/help" component={WMSHelpDesk}/>
                            <Route path="/wms/all/alert" component={UtilsAllAlert}/>
                            <Route path="/wms/quality" component={WMSQualityDefault}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/nbs', '/nbs/home','/nbs/analysis','/nbs/alarm','/nbs/metering','/nbs/all/alert','/nbs/help']}>
                    <MainLayout type={dashboardType.nbs}>
                        <AuthGuard>
                            <Route path="/nbs/home" component={NBSDashboardDefault}/>
                            <Route path="/nbs/analysis" component={NBSAnalysisDefault}/>
                            <Route path="/nbs/alarm" component={NBSAlarms}/>
                            <Route path="/nbs/metering" component={NBSMeteringDefault}/>
                            <Route path="/nbs/all/alert" component={UtilsAllAlert}/>
                            <Route path="/nbs/help" component={NBSHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/agr', '/agr/home','/agr/analysis','/agr/alarm','/agr/all/alert','/agr/help']}>
                    <MainLayout type={dashboardType.agr}>
                        <AuthGuard>
                            <Route path="/agr/home" component={AGRDashboardDefault}/>
                            <Route path="/agr/all/alert" component={UtilsAllAlert}/>
                            <Route path="/agr/help" component={AGRHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/gas', '/gas/home','/gas/analysis','/gas/alarms','/gas/alarms_list','/gas/all/alert','/gas/report','/gas/schedule','/gas/help']}>
                    <MainLayout type={dashboardType.gas}>
                        <AuthGuard>
                            <Route path="/gas/home" component={GasDashboardDefault}/>
                            <Route path="/gas/analysis" component={GasAnalysis}/>
                            <Route path="/gas/alarms" component={GasAlarms}/>
                            <Route path="/gas/alarms_list" component={GasAlarmsList}/>
                            <Route path="/gas/report" component={GasReport}/>
                            <Route path="/gas/schedule" component={GasSchedulePage}/>
                            <Route path="/gas/all/alert" component={UtilsAllAlert}/>
                            <Route path="/gas/help" component={GasHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/steam', '/steam/home','/steam/analysis','/steam/alarms','/steam/all/alert','/steam/alarms_list','/steam/report','/steam/schedule','/steam/help']}>
                    <MainLayout type={dashboardType.steam}>
                        <AuthGuard>
                            <Route path="/steam/home" component={SteamDashboardDefault}/>
                            <Route path="/steam/analysis" component={SteamAnalysis}/>
                            <Route path="/steam/alarms" component={SteamAlarms}/>
                            <Route path="/steam/alarms_list" component={SteamAlarmsList}/>
                            <Route path="/steam/report" component={SteamReport}/>
                            <Route path="/steam/schedule" component={SteamSchedulePage}/>
                            <Route path="/steam/all/alert" component={UtilsAllAlert}/>
                            <Route path="/steam/help" component={SteamHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/air', '/air/home', '/air/dashboard','/air/power_log','/air/backup_log','/air/analysis','/air/alarms','/air/all/alert','/air/alarms_list','/air/report','/air/schedule','/air/help']}>
                    <MainLayout type={dashboardType.air}>
                        <AuthGuard>
                            <Route path="/air/home" component={AirDashboardDefault}/>
                            <Route path="/air/power_log" component={AirPowerLog}/>
                            <Route path="/air/backup_log" component={AirBackupLog}/>
                            <Route path="/air/analysis" component={AirAnalysis}/>
                            <Route path="/air/alarms" component={AirAlarms}/>
                            <Route path="/air/alarms_list" component={AirAlarmsList}/>
                            <Route path="/air/report" component={AirReport}/>
                            <Route path="/air/schedule" component={AirSchedulePage}/>
                            <Route path="/air/all/alert" component={UtilsAllAlert}/>
                            <Route path="/air/help" component={AirHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/flms', '/flms/home','/flms/details','/flms/drivers','/flms/driver_details','/flms/all/alert','/flms/vehicleDetails','flms/help','flms/stats','flms/vehicleAlert','flms/vehicleReport','flms/vehicleScheduleReport','flms/vehicleAlertList']}>
                    <MainLayout type={dashboardType.flms}>
                        <AuthGuard>
                            <Route path="/flms/home" component={FlmsDashboardDefault}/>
                            <Route path="/flms/details" component={FlmsDetailsPage}/>
                            <Route path="/flms/drivers" component={FlmsDriversPage}/>
                            <Route path="/flms/driver_details" component={FlmsDriverLogScreen}/>
                            <Route path="/flms/statistics" component={FlmsStatistics}/>
                            <Route path="/flms/stats" component={FlmsOwnStatistics}/>
                            <Route path="/flms/vehicleDetails" component={FlmsOwnDetails}/> 
                            <Route path="/flms/vehicleAlert" component={FlmsAlarms}/>
                            <Route path="/flms/vehicleAlertList" component={FlmsAlarmsList}/>
                            <Route path="/flms/vehicleReport" component={FlmsReport}/>
                            <Route path="/flms/vehicleScheduleReport" component={FlmsSchedulePage}/>
                            <Route path="/flms/all/alert" component={UtilsAllAlert}/>
                            <Route path="/flms/help" component={FlmsHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>


                <Route path={['/solar', '/solar/home','/solar/details','/solar/analysis','/solar/alarms','/solar/all/alert','/solar/alarms_list',]}>
                    <MainLayout type={dashboardType.solar}>
                        <AuthGuard>
                            <Route path="/solar/home" component={SolarHome}/>
                            <Route path="/solar/details" component={SolarDetails}/>
                            <Route path="/solar/analysis" component={SolarAnalysis}/>
                            <Route path="/solar/alarms" component={SolarAlarms}/>
                            <Route path="/solar/alarms_list" component={SolarAlarmsList}/>
                            <Route path="/solar/all/alert" component={UtilsAllAlert}/>
                            <Route path="/solar/help" component={SolarHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/trans', '/trans/home','/trans/analysis','/trans/alarms','/trans/alarms_list','/trans/report','/trans/all/alert','/trans/schedule','/trans/help']}>
                    <MainLayout type={dashboardType.trans}>
                        <AuthGuard>
                            <Route path="/trans/home" component={TransformerDashboard}/>
                            <Route path="/trans/analysis" component={TransformerAnalysis}/>
                            <Route path="/trans/alarms" component={TransAlarms}/>
                            <Route path="/trans/alarms_list" component={TransAlarmsList}/>
                            <Route path="/trans/report" component={TransReport}/>
                            <Route path="/trans/schedule" component={TransSchedulePage}/>
                            <Route path="/trans/all/alert" component={UtilsAllAlert}/>
                            <Route path="/trans/help" component={TransformerHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route path={['/supportAdmin', '/supportAdmin/home']}>
                    <MainLayout type={dashboardType.supportAdmin}>
                        <AuthGuard>
                            <Route path="/supportAdmin/home" component={TechHelpDesk}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <Route
                    path={[
                        '/ems',
                        '/ems/home',
                        '/ems/ai',
                        // '/ems/comparison',
                        '/ems/mnv',
                        '/ems/alarms',
                        '/ems/alarms_list',
                        "/ems/analysis",
                        '/ems/report_gen',
                        '/ems/add_report',
                        '/ems/ghg',
                        '/ems/power_log',
                        '/ems/kpi',
                        '/ems/kpi_bill',
                        '/ems/ghg',
                        '/ems/support',
                        '/all/alert',
                        '/icons/tabler-icons',
                        '/icons/material-icons',
                        '/sample',
                        '/hooter'
                    ]}
                >
                    <MainLayout type={dashboardType.ems}>
                        <AuthGuard>
                            <Route path="/hooter" component={SamplePage}/>
                            <Route path="/ems/home" component={DashboardDefault}/>
                            <Route path="/ems/ai" component={UtilsEMSAIAnalysis}/>
                            {/* <Route path="/ems/comparison" component={UtilsComparison} /> */}
                            <Route path="/ems/mnv" component={UtilsMnv}/>
                            <Route path="/ems/alarms" component={UtilsAlarms}/>
                            <Route path="/ems/alarms_list" component={UtilsAlarmsList}/>
                            <Route path="/ems/analysis" component={UtilsAnalysis}/>
                            <Route path="/ems/report_gen" component={UtilsReportGen}/>
                            <Route path="/ems/add_report" component={UtilsReportAdd}/>
                            <Route path="/ems/ghg" component={UtilsGhg}/>
                            <Route path="/ems/power_log" component={UtilsPowerLog}/>
                            <Route path="/ems/kpi" component={UtilsKpi}/>
                            <Route path="/ems/kpi_bill" component={UtilsKpiBill}/>
                            <Route path="/ems/support" component={UtilsSupport}/>
                            <Route path="/ems/all/alert" component={UtilsAllAlert}/>
                            <Route path="/ems/icons/tabler-icons" component={UtilsTablerIcons}/>
                            <Route path="/icons/material-icons" component={UtilsMaterialIcons}/>
                            <Route path="/sample-page" component={SamplePage}/>
                        </AuthGuard>
                    </MainLayout>
                </Route>

                <AuthGuard>
                    <Route path="*" component={NotFound}/>
                    <Route path="/notFound" component={NotFound}/>
                </AuthGuard>
            </Switch>
            {/* <SessionExpiredModal isOpen={isSessionExpiredModalOpen} onLogout={handleLogout}/> */}
        </div>
    );
};

export default MainRoutes;